import { Alerts } from "../../../utils/Alerts.js";
import { RPCs } from "../../../services/rpc.js";
import { useRPCContext } from "../../../contexts/RPCContext.js";
import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { useEffect, useState } from "react";
import { ColorCircle, Select } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Tags/shared/SelectActivityTypeTag.tsx
var SelectActivityTypeTagRenderComponents = {
	ListItem: (tagOption) => /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(ColorCircle, {
		color: tagOption.color,
		marginRight: true,
		variant: "neutral"
	}), /* @__PURE__ */ jsx("span", { children: tagOption.title })] }),
	SelectedMulti: (tag, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
		onRemove,
		children: /* @__PURE__ */ jsxs("div", {
			className: "px-xs gap-x-xs inline-flex items-center overflow-hidden text-sm",
			children: [/* @__PURE__ */ jsx(ColorCircle, {
				color: tag.color,
				variant: "neutral"
			}), /* @__PURE__ */ jsx("span", {
				className: "truncate",
				children: tag.title
			})]
		})
	}),
	SelectedSingle: (tag) => /* @__PURE__ */ jsxs("div", {
		className: "py-xs gap-x-sm inline-flex items-baseline text-sm",
		children: [/* @__PURE__ */ jsx(ColorCircle, {
			color: tag.color,
			variant: "neutral"
		}), /* @__PURE__ */ jsx("span", {
			className: "truncate",
			children: tag.title
		})]
	})
};
function SelectActivityTypeTag({ multi = true, organizationId, ...atalayaSelectProps }) {
	const { rpcClient, rpcService } = useRPCContext();
	const [options, setOptions] = useState(() => rpcClient.getCallCache(RPCs.Tags.GetActivityTypeTagsList.v1, { organizationId })?.data?.tags || []);
	const [loading, setLoading] = useState(!options.length);
	useEffect(() => {
		if (!options.length) rpcService.Tags.GetActivityTypeTagsList.v1.call({
			organizationId,
			pagination: { limit: 500 }
		}).then(({ data }) => setOptions(data.tags)).catch((err) => Alerts.error("Unable to load Activity Types list", err.message)).finally(() => setLoading(false));
	}, []);
	return /* @__PURE__ */ jsx(Select, {
		RenderListItem: SelectActivityTypeTagRenderComponents.ListItem,
		RenderSelectedMulti: SelectActivityTypeTagRenderComponents.SelectedMulti,
		RenderSelectedSingle: SelectActivityTypeTagRenderComponents.SelectedSingle,
		isLoading: loading,
		multi,
		optionLabelExtractor: ({ title }) => title,
		options,
		optionValueExtractor: ({ id }) => id,
		...atalayaSelectProps
	});
}
//#endregion
export { SelectActivityTypeTag, SelectActivityTypeTagRenderComponents };

//# sourceMappingURL=SelectActivityTypeTag.js.map